import './index.scss';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation }  from 'react-router-dom';
import { addPopup, setMegaMenuId, setLoginId, setLoginFormName, setLoginCode, getHomepage }  from 'redux/actions';
import AnalyticsManager             from 'app/analytics';
import { getMediaPath }             from 'app/functions';
import * as Routes                  from 'constants/routes';
import * as popups                  from 'constants/popup-types';

/* Assets */
import Burger           from 'assets/icons/burger-mobile-icon.svg';
import Logo             from 'assets/logos/hot-new.svg';
import LogoYellow       from 'assets/logos/logo_yellow.svg';
import Fav              from 'assets/icons/benefit-fav.svg';
import FavOn            from 'assets/icons/benefit-fav-full.svg';
import PersonalDetails  from 'assets/icons/personal-details.svg';
import LoggedIn         from 'assets/icons/logged-in.svg';

/* Components */
import HoverButton      from './components/hover-button';
import MegaMenuStrip    from './components/mega-menu-strip';
import MegaMenu         from './components/mega-menu';
import Search           from './components/search';
import MobileMenu       from './mobile';
import Cookies from 'components/cookies/cookies';
import HotYoterEligiblesPopup from './components/hot-yoter-eligibles-popup';
import { HOT_YOTER_DEFAULT_SLUG } from '../hot_yoter/constants';

const Header = (props) => {
    const megaMenuRef = useRef();
    const headerRef = useRef();
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const state = useSelector(store => store.state);
    const config = useSelector(store => store.config);
    const [burgerOpen, setBurgerOpen] = useState(false);
    const [isCookiesOpen, setIsCookiesOpen] = useState(false);
    const homepageLogos = useSelector(store => store.config.HomepageLogos);
    const homepageData = useSelector(store => store.data.HomepageData);
    const benefitPage = useSelector(store => store.data.BenefitPage);
    const parameters = useSelector(store => store.config.Parameters);
    const {
        MainCategoryMenu: mainCategories,
        SubCategoryMenu: subCategories,
        Translations: texts,
        UserData: userData,
        contentWorldsArr,
        categoriesArr,
        MainMenu,
    } = config;
    const {
        benefitSearchFilters: Filters,
        deviceState,
        searchState,
        megaMenuId
    } = state;

    useEffect(() => {
        dispatch(setMegaMenuId(null));
    }, [location.pathname])

    useEffect(() => {
        const checkCookies = () => {
            const name = "hot_cookies_accepted=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            let cookieValue = "";
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    cookieValue = c.substring(name.length, c.length);
                }
            }
            setIsCookiesOpen(cookieValue !== 'true');
        };

        checkCookies();
        const interval = setInterval(checkCookies, 100);
        return () => clearInterval(interval);
    }, [])

    useEffect(() => {
        document.addEventListener('mouseover', handleBodyClick);
        return () => {
            document.removeEventListener('mouseover', handleBodyClick);
        }
    }, [megaMenuId]);

    const handleBodyClick = (e) => {
        if(megaMenuId !== null){
            const path = e.composedPath();
            const isFather = path.indexOf(headerRef.current) !== -1
                             || path.indexOf(megaMenuRef.current) !== -1;
            if(!isFather){
                dispatch(setMegaMenuId(null));
            }
        }
    };
    const handlePrivateZoneClick = (route) =>{
        dispatch(setLoginId(''));
        dispatch(setLoginFormName('id_login_form'))
        dispatch(setLoginCode(0))
        if (!userData) {
            dispatch(addPopup({
                type: popups.LOGIN
            }))
        } else {
            switch (route) {
                case Routes.user_info:
                    AnalyticsManager.logMenuPersonalZonePress();
                    break;
                case Routes.favorites:
                    AnalyticsManager.logMenuFavoritesPress();
                    break;
            }

            history.push(route);
        }
    };

    const getFavoritesMessage = () => {
        if(userData && userData.favoritesArr.length === 0){
            return texts['fav_msg_logged'];
        }
        return "";
    }

    const handleBurgerClose = () => {
        setBurgerOpen(false);
    }
    const handleBurgerOpen = () => {
        setBurgerOpen(true);
    }

    const isMobile = deviceState === 'mobile';
    const decodedPathname = decodeURI(location.pathname);
    const isHomepage = decodedPathname === Routes.home
        || decodedPathname.startsWith(`${Routes.home}/`);
    const hotYoterBenefitsPath = `${Routes.hot_yoter}/${HOT_YOTER_DEFAULT_SLUG}`;
    const isHotYoterPage = decodedPathname === hotYoterBenefitsPath
        || decodedPathname.startsWith(`${Routes.hot_yoter}/`);
    const isBenefitPage = decodedPathname.startsWith(`${Routes.benefit}/`);
    const isSubsidizedBenefitPage = isBenefitPage
        && benefitPage
        && benefitPage !== 'error'
        && (benefitPage.main.is_subsidized === true || Number(benefitPage.main?.is_subsidized) === 1 || Number(benefitPage.main?.is_subsidized) === 2);
    const shouldShowHotYoterEligiblesPopup = Number(parameters?.hotyoter?.display_hotyoter_panel_main_screen) && userData && (
        isHomepage || (!isMobile && isHotYoterPage) || isSubsidizedBenefitPage
    );
    useEffect(() => {
        if (shouldShowHotYoterEligiblesPopup && isHomepage && !homepageData) {
            dispatch(getHomepage());
        }
    }, [shouldShowHotYoterEligiblesPopup, isHomepage, homepageData, dispatch]);

    const handleHotYoterEligiblesNavigate = () => {
        if (!isHotYoterPage) {
            history.push(hotYoterBenefitsPath);
        }
    };
    const logo = homepageLogos?.website_logo?.length > 0 ? getMediaPath(homepageLogos?.website_logo) : getMediaPath(Logo);
    const hotYoterEligiblesPopup = shouldShowHotYoterEligiblesPopup ? (
        <HotYoterEligiblesPopup
            userData={userData}
            hideActionLabel={isHotYoterPage}
            onDetailsPress={handleHotYoterEligiblesNavigate}
            onChooseBenefitPress={handleHotYoterEligiblesNavigate}
        />
    ) : null;
    return (
        <>
        
            {isMobile && (
                <div className={`space-before-header ${isCookiesOpen ? 'cookies-open' : ''}`} />
            )}

            <header className="header" data-nosnippet="true">
            <Cookies/>
                {!isMobile && (
                    <div className={`space-before-header ${isCookiesOpen ? 'cookies-open' : ''}`} />
                )}

                <div className="header-wrapper" ref={headerRef}>
                    <div className="logo-strip">
                        <div className="right-side">
                            {isMobile && (
                                <button  className="burger-wrapper" onClick={handleBurgerOpen}>
                                    <img src={getMediaPath(Burger)} alt="תפריט מובייל" className='burger-icon' />
                                </button>
                            )}

                            <button data-hbo={'homepage-logo'} className="logo-wrapper" onClick={() => history.push(Routes.home)}>
                                <img src={logo} alt="לוגו הוט" className='logo'/>
                            </button>
                        </div>

                        <Search />

                        <div className="personal-area">
                            <HoverButton
                                icon={PersonalDetails}
                                hoverIcon={LoggedIn}
                                text={userData ? (`שלום ${userData['first_name']}`):texts['header_personal_zone']}
                                onClick={() => handlePrivateZoneClick(Routes.user_info)}
                            />

                            {userData && (
                                <HoverButton
                                    icon={Fav}
                                    hoverIcon={FavOn}
                                    text={texts['header_favorites_link']}
                                    hoverText={getFavoritesMessage()}
                                    onClick={() => handlePrivateZoneClick(Routes.user_info + Routes.user_info_routes.favorites)}
                                />
                            )}

                            {!isMobile && hotYoterEligiblesPopup}
                        </div>
                    </div>

                    {!isMobile && (
                        <MegaMenuStrip />
                    )}
                </div>

                {isMobile && hotYoterEligiblesPopup}

                {!isMobile && (
                    <MegaMenu ref={megaMenuRef}/>
                )}

                {isMobile && (
                    <MobileMenu
                        open={burgerOpen}
                        onClose={handleBurgerClose}
                        pathname={location.pathname}
                    />
                )}
            </header>
    </>
    );
}

export default Header;
